export default __webpack_public_path__ + "755af0e94e5162d40b8a41da70579dcb.png";